<div
  class="cc-sidebar-container pt-1"
  [style.width.px]="sidebarWidth"
  (mouseenter)="expandSidebar()"
  (mouseleave)="collapseSidebar()"
>
  <nav class="nav flex-column">
    <!-- Botón HOME -->
    <div class="row">
      <div class="col-12">
        <div class="cc-container-btn-sidebar">
          <button
            type="button"
            class="cc-btn-sidebar"
            routerLink="/home"
            (click)="selectOptionSidebar('home')"
            [ngClass]="{ selected: activeHome && !sidebarComprimido }"
            [disabled]="isGuest == true"
            >
            <img 
              height="40px" width="40px"
              src="/assets/img/icon-home{{ activeHome ? '-blue' : '' }}.svg"
              [ngClass]="{ selected: activeHome && sidebarComprimido }"
            />HOME
          </button>
                    <button
            type="button"
            class="cc-btn-sidebar"
            routerLink="/process-list"
            (click)="selectOptionSidebar('process-list')"
            [ngClass]="{ selected: activeProcessList && !sidebarComprimido }"
            [disabled]="isGuest == true"
            >
            <img 
              height="40px" width="40px"
              src="/assets/img/remuneracion{{ activeProcessList ? '-blue' : '' }}.svg"
              [ngClass]="{ selected: activeProcessList && sidebarComprimido }"
            />Centralización
          </button>
        </div>
      </div>
    </div>


  </nav>
</div>
